import { Box, BoxList, Button, Icon, Text } from '@factorialco/deprecated-design-system'
import { IntegrationsJoinIntegrationConfiguration } from 'generated/resources/graphql'
import { startCase } from 'lodash'

import i18n from 'modules/core/lib/i18n'

import DropzoneBox from 'modules/documents/components/Documents/DropzoneBox'

interface Props {
  currentFile?: File
  option: IntegrationsJoinIntegrationConfiguration
  onFileChange: (value: File | undefined) => void
}

export const ExternalProfileConfigurationFile = ({ currentFile, option, onFileChange }: Props) => {
  return (
    <Box width="full" gap="s8" justifyContent="spaceBetween">
      <Text.Normal size="200" weight="semibold">
        {startCase(option.slug)}
      </Text.Normal>
      {currentFile ? (
        <BoxList>
          <BoxList.Item>
            <Box
              width="full"
              justifyContent="spaceBetween"
              flexDirection="row"
              alignItems="center"
              gap="s12"
            >
              <Box flexDirection="row" alignItems="center" gap="s4">
                <Icon.Medium icon="file-filled" />
                <Text.Normal size="300" color="grey1000" ellipsis overflowWrap>
                  {currentFile.name}
                </Text.Normal>
              </Box>
              <Button type="secondary" iconName="delete" onClick={() => onFileChange(undefined)} />
            </Box>
          </BoxList.Item>
        </BoxList>
      ) : (
        <DropzoneBox
          onDrop={(files: File[]) => onFileChange(files[0])}
          message={i18n.t('documents.drop_here')}
          // TODO: remove this when join provide it
          accept={{ 'application/x-pkcs12': [] }}
        />
      )}{' '}
    </Box>
  )
}
